import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function TermsNotice() {
  return (
    <div className="flex flex-col items-center text-center mt-6 p-6 bg-zinc-900/30 border border-white/5 rounded-[2rem]">
      <p className="text-sm font-medium leading-relaxed text-slate-400">
        Ao confirmar seu agendamento, você concorda com nossos{" "}
        <Dialog>
          <DialogTrigger className="text-primary hover:underline font-bold">
            Termos de Uso e Privacidade
          </DialogTrigger>
          <DialogContent className="bg-zinc-950 border-white/10 text-white max-w-2xl max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="text-2xl font-black text-primary uppercase">Termos de Uso e Política de Privacidade</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 text-slate-300 text-sm leading-relaxed pb-6 text-left">
              <h3 className="font-bold text-white text-lg mt-4">1. Coleta de Dados</h3>
              <p>
                Coletamos apenas as informações necessárias para a prestação do serviço de agendamento: seu nome, telefone para contato e o histórico dos serviços agendados conosco.
              </p>

              <h3 className="font-bold text-white text-lg mt-4">2. Uso das Informações</h3>
              <p>
                Seus dados são utilizados exclusivamente para gerenciar seus agendamentos, enviar lembretes (se aplicável), e para nosso controle interno de atendimento e fidelização.
              </p>

              <h3 className="font-bold text-white text-lg mt-4">3. Compartilhamento</h3>
              <p>
                Garantimos que suas informações pessoais <strong>não serão vendidas, alugadas ou compartilhadas</strong> com terceiros não envolvidos na prestação do serviço, exceto quando exigido por lei.
              </p>

              <h3 className="font-bold text-white text-lg mt-4">4. Segurança</h3>
              <p>
                Adotamos medidas de segurança para proteger seus dados contra acessos não autorizados. No entanto, nenhum sistema é 100% seguro.
              </p>

              <h3 className="font-bold text-white text-lg mt-4">5. Seus Direitos</h3>
              <p>
                Você pode solicitar a qualquer momento a exclusão ou alteração dos seus dados em nosso sistema entrando em contato com a administração do estabelecimento.
              </p>
            </div>
          </DialogContent>
        </Dialog>.
      </p>
      <p className="text-xs text-slate-500 mt-2">
        Coletamos apenas o essencial para gerenciar sua reserva.
      </p>
    </div>
  );
}
